var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.41L11.58 12L5 18.59L6.41 20L14.41 12L6.41 4L5 5.41ZM17.41 4H19.41V20H17.41V4Z",
    fill: "#DADCE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLast);
export default __webpack_public_path__ + "static/media/last.4cee54265747e39f306996470e8b3752.svg";
export { ForwardRef as ReactComponent };